import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';

const WhyAIEngineering = ({ content }) => {
  const { stats, roles } = content;
  return (
    <section id="why">
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>Why AI Engineering, Why Now</h2>
          <p>
            Every product team is adding LLM features. Very few engineers can ship them reliably.
            The gap isn&apos;t prompting — it&apos;s retrieval, evals, agents, cost control and
            production operations.
          </p>
        </div>
        <div className={`${styles.tiles} ${styles.t3}`}>
          {stats.map((stat) => (
            <div className={styles.tile} key={stat.n}>
              <div className={styles.n}>{stat.n}</div>
              <div className={styles.l}>{stat.l}</div>
              <div className={styles.src}>{stat.src}</div>
            </div>
          ))}
        </div>
        <div className={styles.roles}>
          <span className={styles.stackH}>Roles this program prepares you for</span>
          <div className={styles.stackRow}>
            {roles.map((role) => (
              <span className={`${styles.chip} ${styles.g}`} key={role}>
                {role}
              </span>
            ))}
          </div>
        </div>
        <div className={styles.explain}>
          <div>
            <span className={styles.eyebrow}>AI Engineer vs Forward-Deployed Engineer</span>
            <h3>What&apos;s the difference — and which one is this?</h3>
            <p>
              An <b>AI Engineer</b> builds and operates AI systems: retrieval, agents, evals,
              fine-tuning, serving. A <b>Forward-Deployed Engineer</b> takes those systems into a
              customer&apos;s organisation: discovery, scoping, integration, adoption — and owning
              the outcome.
            </p>
          </div>
          <div className={styles.explainR}>
            <p>
              <b>This program is both, in that order.</b> Six sprints build the AI-engineering
              core in depth. The problem → production (FDE) work cycle is layered on top — every
              guided project ships with a spec, success metrics and a demo narrative, and the
              capstone runs the full cycle — and a 2-week Interview Preparation Sprint targets AI
              Engineer and FDE interviews. You graduate able to go either way.
            </p>
            <a href="#fde">See problem → production</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyAIEngineering;
